export const Footer = {
  marginTop: 5,
  paddingY: 5,
  backgroundColor: 'footerBg',
  color: 'onFooterBg',
  display: 'block',
  a: {
    color: 'onFooterBg',
  },
  borderTop: '1px solid',
  borderTopColor: 'lightGray',
};

export const Container = {};

export const Title = {
  marginBottom: 5,
};

export const InformationRow = {
  paddingY: 5,
};

export const CopyrightRow = {
  textAlign: 'center',
  paddingY: 5,
};

export const Address = {
  marginBottom: 0,
  p: {
    marginBottom: 0,
  },
};

export const FooterNavigation = {
  // flexDirection: 'column',
  ul: {
    paddingLeft: 0,
    marginBottom: 0,
  },
};

export const FooterNavItem = {
  listStyle: 'none',
  color: 'inherit',
  a: {
    color: 'inherit',
  },
};

export const SocialMediaStyles = {
  SocialMediaWrapper: {},

  SocialMedia: {
    margin: ['1rem 0 0 0', null, '0 auto', null],
  },

  Item: {
    marginRight: '10px',
    ':last-child': {
      marginRight: 0,
    },
    color: 'accent',
  },
};

export const Logo = {
  maxWidth: '150px',
  marginBottom: 4,
};
